// extracted by mini-css-extract-plugin
export default {"cell":"confirmation_cell__LH5Xl","textCenter":"confirmation_textCenter__-PAa7","textLeft":"confirmation_textLeft__02U2N","textRight":"confirmation_textRight__f6tRB"};